import styled from 'styled-components';

import CardStyle from '@components/Card';

export const Card = styled(CardStyle)`
  background: ${({ theme }) => theme.palette.background.paper};
  height: 100%;
  overflow: auto;
  z-index: 2;
  max-height: calc(100vh - 56px);
`;

export const InnerModal = styled.div`
  width: 100%;
  z-index: 2;
  ${(props) => props.theme.breakpoints.down('lg')} {
    & > div > div {
      flex-wrap: wrap;
    }
  }
`;

export const OuterModal = styled.div<{
  width?: number | string;
}>`
  width: ${(props) =>
    typeof props.width === 'number' ? `${props.width}px` : props.width};
  max-width: 95%;
  max-height: 95%;
  height: auto;
  z-index: 2;
  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
  }
`;

export const FilteredBackground = styled.div`
  background-color: ${({ theme }) => theme.palette.grey['900']}24;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1000px;
  width: 80%;
  ${(props) => props.theme.breakpoints.up('sm')} {
    margin-left: 33px;
  }
  ${(props) => props.theme.breakpoints.down('lg')} {
    margin-top: 56px;
  }
  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-top: 56px;
    width: 95%;
  }
`;

export const OverlayContainer = styled.div<{
  isOpen?: boolean;
}>`
  z-index: 12;
  height: 100%;
  position: fixed;
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  top: 0;
  left: 0;
`;
